
import { JsonProperty, JsonObject } from 'typescript-json-serializer';

/**
 * Container class for permission information
 *
 * @export
 * @class Permission
 */
@JsonObject()
export class Permission {
  @JsonProperty('Type') type: string;
  @JsonProperty('AssigneeId') assigneeId: string;
  @JsonProperty('AssigneeType') assigneeType: string;
  @JsonProperty('AssigneeName') assigneeName: string;
  @JsonProperty('TargetResourceType') targetResourceType: string;
  @JsonProperty('TargetResourceId') targetResourceId: string;
}
